import { EnergyTrainingZone } from "./consultationTypes";

/**
 * True when the `GetConsultation` zones carry a measurement — the one rule
 * that decides whether Energy & Training is shown, in the consultation (sub
 * step + sidebar row) and in the Health overview (Energy & Training Zones
 * system). A client without an AMR test still gets five zones, every bound 0,
 * so a length check is not enough; an unmeasured range can also arrive as
 * `null`.
 */
export const hasZoneData = (
  zones: EnergyTrainingZone[] | null | undefined
): boolean =>
  (zones ?? []).some((z) =>
    [z.hr, z.watts, z.speed].some((r) => !!r && (r.lower !== 0 || r.upper !== 0))
  );
